/* eslint-disable import/prefer-default-export */
export const addListType = contentTypeId => `ADD_LIST_${contentTypeId}`;
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/store/contentfulRedux/factories/actionTypes.js